import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LmsSidebar from "./components/LmsSidebar";
import LmsTopbar from "./components/LmsTopbar";
import "./lms.css";

export default function LmsLayout() {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, []);

  // Close sidebar when clicking outside (overlay)
  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <>
      <div className="lms-shell">
        {/* Mobile overlay */}
        {sidebarOpen && (
          <div className="lms-sidebar-overlay" onClick={handleOverlayClick} />
        )}

        {/* Sidebar */}
        <LmsSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Main area */}
        <div className="lms-main">
          {/* Topbar */}
          <LmsTopbar
            onUploadClick={() => setUploadModalOpen(true)}
            onMenuClick={() => setSidebarOpen((o) => !o)}
          />

          {/* Page content — child routes render here */}
          <main className="lms-content">
            <Outlet context={{ uploadModalOpen, setUploadModalOpen }} />
          </main>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </>
  );
}
